<template>
  <q-section :bg-i="uiMeta?.images?.recordOpenButton" v-bind="uiMeta?.layout?.recordWrapper" @click="open(trueActive)">
    <q-dialog name="record" pc="pc">
      <q-section :bg-i="uiMeta?.images?.recordBg[trueActive]" p="relative">
        <q-section v-bind="uiMeta?.layout?.recordContentWrapper">
          <van-list
            v-if="recordInfo.list.length > 0"
            style="width: 100%; height: 100%; overflow-y: auto; scrollbar-width: none"
            v-model="recordInfo.loading"
            :finished="recordInfo.finished"
            :loading-text="recordInfo.loadingText"
            :offset="10"
            @load="recordLoad(trueActive)"
            :immediate-check="false">
            <q-section
              v-bind="uiMeta?.layout?.recordItemWrapper"
              v-for="(item, index) in recordInfo.list"
              :key="index"
              p="relative">
              <q-section class="flex items-center" v-bind="uiMeta?.layout?.recordItemTextWrapper">
                {{ uiMeta.config.rewardDesc.replace('{reward_name}', item.reward_name) }}
              </q-section>
              <q-section class="flex items-center" style="text-align: right" v-bind="uiMeta?.layout?.recordItemTimeWrapper">
                {{ dayjs(item.lottery_timestamp).format('MM月DD日 HH:mm') }}
              </q-section>
              <q-section v-bind="uiMeta?.layout?.recordItemDividerWrapper" style="opacity: 0.5" pc="x" pb="0"></q-section>
            </q-section>
          </van-list>
          <q-section v-else v-bind="uiMeta?.layout?.recordEmptyWrapper" pc="pc">
            {{ uiMeta.config.recordEmptyText }}
          </q-section>
        </q-section>
      </q-section>
    </q-dialog>
  </q-section>
</template>

<script setup>
import { nextTick, watch, ref } from 'vue'
import dayjs from 'dayjs'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
import { useRecord } from './use-record'

const { $dialogs } = useDialogs()
const trueActive = ref(0)

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  active: {
    type: Number,
    default: 0,
  },
})

const { recordInfo, recordLoad, clearData } = useRecord(props.uiMeta)

watch(
  () => props.active,
  () => {
    trueActive.value = props.active
  },
  {
    immediate: true,
  }
)

const open = async () => {
  recordLoad(trueActive.value)
  await nextTick()
  $dialogs.record.open({
    onclose: () => {
      clearData()
    },
  })
}
</script>

<style scoped lang="scss"></style>
